/* @flow */

import { type Produto, type ProdutoPedidoCompleto, type ChavesItem } from './types';

const chavesItemPadrao = {
    id: 0,
    quantidade: 0,
    observacao: '',
    complementos: [],
};

const converterProdutoParaItem = (
    produto: ?Produto,
    chavesItem: ChavesItem = chavesItemPadrao,
): ?ProdutoPedidoCompleto => (
    !produto ? null : {
        ...produto,
        ...chavesItem,
        pedidosProdutosId: 0,
        id: chavesItem.id,
        produtosId: produto.id,
    }
);

export default converterProdutoParaItem;
